import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="pt-16 md:pt-20">
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 py-24 md:py-32 text-center">
          <p className="font-heading font-black text-7xl md:text-9xl text-background-300 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading font-black text-2xl md:text-3xl text-foreground-950">
            这页档案可能还没归档
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 break-all">
            找不到路径：{location.pathname}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              回到首页
            </Link>
            <Link
              to="/cases"
              className="w-full sm:w-auto px-6 py-3 rounded-md text-sm font-medium border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              浏览塌房合集
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default NotFound;